import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import TooltipIconClick from '@/components/info/TooltipIconClick.vue';
import localization from '@/i18n';
import { fullName } from '@/lib/employee/employeeFunctions';
import { AppWarningEnum } from '@/lib/enum/AppWarningEnum';
import { Icon } from '@/lib/enum/Icon';
import { redirect } from '@/router/router';
import { routes } from '@/router/routes';
import store from '@/store';
import { keyOfFirstTruthyValue } from '@/util/objectFunctions';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarWarning',
  setup(__props) {

const loading = ref(false);

const loggedInEmployee = computed(() => store.getters.loggedInEmployee);
const currentCompany = computed(() => store.getters.currentCompany);
const allWarnings = computed(() => store.state.appWarnings.warning);
const isImpersonationSession = computed(
  () => store.state.isImpersonationSession,
);
const showWarning = computed(
  () => !!allWarnings.value.length || isImpersonationSession.value,
);

const displayedWarning = computed<AppWarningEnum | null>(() => {
  if (!allWarnings.value.length) {
    return null;
  }

  return (
    keyOfFirstTruthyValue({
      [AppWarningEnum.Refresh]: allWarnings.value.includes(
        AppWarningEnum.Refresh,
      ),
      [AppWarningEnum.WebsocketDisconnected]: allWarnings.value.includes(
        AppWarningEnum.WebsocketDisconnected,
      ),
      [AppWarningEnum.WebsocketReconnecting]: allWarnings.value.includes(
        AppWarningEnum.WebsocketReconnecting,
      ),
    }) || null
  );
});

const icon = computed<string>(
  () =>
    keyOfFirstTruthyValue({
      [Icon.User]: isImpersonationSession.value,
      [Icon.Loading]:
        displayedWarning.value === AppWarningEnum.WebsocketReconnecting,
      [Icon.ArrowsRotate]: [
        AppWarningEnum.Refresh,
        AppWarningEnum.WebsocketDisconnected,
      ].includes(displayedWarning.value),
    }) || '',
);

const title = computed<string>(() => {
  if (displayedWarning.value === AppWarningEnum.Refresh) {
    return localization.tc('warningMessage.refreshShiftie');
  }
  if (displayedWarning.value === AppWarningEnum.WebsocketReconnecting) {
    return localization.tc('warningMessage.reconnectingWebsockets');
  }
  if (displayedWarning.value === AppWarningEnum.WebsocketDisconnected) {
    return localization.tc('warningMessage.reloadShiftie');
  }
  return '';
});

const tooltip = computed<string>(() => {
  if (displayedWarning.value === AppWarningEnum.Refresh) {
    return localization.tc('tooltip.refreshShiftie');
  }
  if (displayedWarning.value === AppWarningEnum.WebsocketReconnecting) {
    return localization.tc('tooltip.reconnectingShiftieWebsockets');
  }
  if (displayedWarning.value === AppWarningEnum.WebsocketDisconnected) {
    return localization.tc('tooltip.refreshShiftieWebsocket');
  }
  return '';
});

const clickable = computed<boolean>(() => !isImpersonationSession.value);

const showButton = computed(() => isImpersonationSession.value);

const refresh = () => window.location.reload();
const logout = () => redirect(routes.logout.route());

const buttonText = computed<string>(() => {
  if (isImpersonationSession.value) {
    return localization.tc('button.stopImpersonation');
  }
  return '';
});

const buttonColour = computed<string>(() => {
  if (isImpersonationSession.value) {
    return 'outline-red';
  }
  return '';
});

const buttonAction = computed<Function>(() => {
  if (isImpersonationSession.value) {
    return logout;
  }
  return refresh;
});

return { __sfc: true,loading, loggedInEmployee, currentCompany, allWarnings, isImpersonationSession, showWarning, displayedWarning, icon, title, tooltip, clickable, showButton, refresh, logout, buttonText, buttonColour, buttonAction, Button, TooltipIconClick, fullName }
}

})